import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const SearchWrapper = styled.div`
  width: 500px;
  height: 45px;
  display: block;
  margin: 0 auto;
  position: relative;
  justify-self: right;
`;

const SearchBar = styled.input`
  width: 500px;
  height: 45px;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0 auto;
  padding: 0 20px;
  font-size: 1rem;
  border: 1px solid #d0cfce;
  outline: none;
  &:focus {
    border: 1px solid #008abf;
    transition: 0.35s ease;
    color: #008abf;
    &::-webkit-input-placeholder {
      transition: opacity 0.45s ease;
      opacity: 0;
    }
    &::-moz-placeholder {
      transition: opacity 0.45s ease;
      opacity: 0;
    }
    &:-ms-placeholder {
      transition: opacity 0.45s ease;
      opacity: 0;
    }
  }

  ${({ disableSteps }) =>
    disableSteps &&
    css`
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0;
      }
    `}

  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export default class Search extends PureComponent {
  static propTypes = {
    disableSteps: PropTypes.bool,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    type: PropTypes.string,
  };

  static defaultProps = {
    disableSteps: false,
    disabled: false,
    placeholder: '',
    type: 'text',
  };

  onKeyPress = event => {
    const { value: searchKey } = (event && event.target) || {};
    const { onSearch } = this.props;

    if (event.key === 'Enter' && searchKey !== '') onSearch(searchKey);
  };

  render() {
    const { placeholder, disabled, type, disableSteps } = this.props;

    return (
      <div>
        <SearchWrapper>
          <SearchBar
            onKeyPress={this.onKeyPress}
            placeholder={placeholder}
            disabled={disabled}
            type={type}
            disableSteps={disableSteps}
          />
        </SearchWrapper>
      </div>
    );
  }
}
